<template>
  <div>
    <el-row class="flow-setting" :gutter="8">
      <el-col :span="1">
      </el-col>
      <el-col class="left-area" :span="6">
        <div>
          <div class="left-top">
            <el-input size="small" v-model="searchText"></el-input>
            <el-button type="primary" size="small" style="margin-left: 2px;"
                       @click="onSearchClick(searchText)">搜索
            </el-button>
          </div>

          <el-table class="left-content" :border="true" :show-header="false" :data="flowListShow"
                    style="width: 100%" @row-click="onFlowClick">
            <el-table-column prop="name" label="名称">
            </el-table-column>
          </el-table>
          <div class="left-bottom">
            <el-button class="left-bottom-btn" type="primary" @click="onAddClick" :disabled="!hasCommitPermission">
              添加
            </el-button>
          </div>
        </div>
      </el-col>

      <el-col :span="2">
      </el-col>

      <el-col class="right-area" :span="15">
        <div>
          <el-form class="main-form" label-position="left" label-width="80px" :model="selectFlow" size="mini">
            <el-form-item label="流程名称">
              <el-input :disabled="true" class="form-item-width" v-model="selectFlow.name"
                        placeholder="请输入流程名称" maxlength="36" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="日期范围">
              <el-radio-group :disabled="true" v-model="selectFlow.triggerDate">
                <el-radio label="ALL">全年</el-radio>
                <el-radio label="WORK_DAY">工作日</el-radio>
                <el-radio label="NON_WORK_DAY">非工作日</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="hasSelectFlow">
              <el-form-item label="时间范围">
                <el-time-picker class="form-item-width" :disabled="true" is-range
                                v-model="selectFlow.timeArea" range-separator="至" start-placeholder="开始时间"
                                end-placeholder="结束时间" placeholder="选择时间范围">
                </el-time-picker>
              </el-form-item>
              <el-form-item label="对象范围">
                <el-radio-group :disabled="true" v-model="selectFlow.targetType">
                  <el-radio label="ALL">全体</el-radio>
                  <el-radio label="DEPARTMENT">部门</el-radio>
                  <el-radio label="PEOPLE">指定人员</el-radio>
                </el-radio-group>
              </el-form-item>
            </template>

            <el-button @click="onEdiitClick" class="edit-btn" v-if="hasSelectFlow" size="mini"
                       type="primary">编辑
            </el-button>
          </el-form>

          <FlowShowView v-if="hasSelectFlow" @message="getChildMsg" :flowItemInfo="selectFlow.approves"
                        :markCopy="selectFlow.makeCopies" :visitType="visitType">
          </FlowShowView>
        </div>
      </el-col>
    </el-row>

    <el-drawer class="drawer-content" :title="drawFlowForm.title" :visible.sync="drawerShow" :with-header="false"
               direction="rtl" size="600px" :before-close="onDrawerClosse">

      <div class="container">
        <header>{{ drawTitle }}</header>
        <main>
          <el-form label-position="left" label-width="80px" size="mini" :model="drawFlowForm">

            <el-form-item :rules="[{required: true}]" label="流程名称">
              <el-input v-model="drawFlowForm.name" placeholder="请输入流程名称" maxlength="36"
                        show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="日期范围">
              <el-radio-group v-model="drawFlowForm.triggerDate">
                <el-radio label="ALL">全年</el-radio>
                <el-radio label="WORK_DAY">工作日</el-radio>
                <el-radio label="NON_WORK_DAY">非工作日</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间范围">
              <el-time-picker class="form-item-width" is-range v-model="drawFlowForm.timeArea" format="HH:mm"
                              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                              placeholder="选择时间范围">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="对象范围">
              <el-radio-group v-model="drawFlowForm.targetType">
                <el-radio label="ALL" :disable="true">全体</el-radio>
                <el-radio label="DEPARTMENT">部门</el-radio>
                <el-radio label="PEOPLE">指定人员</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-select class="select-width" v-if="drawFlowForm.targetType === 'DEPARTMENT'" key="DEPARTMENT"
                         v-model="drawFlowForm.department" placeholder="请选择部门" value-key="id"
                         :popper-append-to-body="false">
                <el-option :value="departmentList" class="setstyle" style="overflow: auto; height: 100%"
                           disabled :key="departmentList.id" :label="departmentList.name">
                  <el-tree style="min-height: 150px; max-height: 300px" :data="selectTreeDepartment"
                           :props="defaultProps" ref="tree" check-strictly :expand-on-click-node="false"
                           @node-click="(data, node, item) => nodeClickGroup(data, node, item)"></el-tree>
                </el-option>
              </el-select>

              <el-select class="select-width" value-key="id" v-else-if="drawFlowForm.targetType === 'PEOPLE'"
                         key="PEOPLE" v-model="drawFlowForm.people" filterable remote reserve-keyword
                         placeholder="请输入姓名或手机号" :remote-method="NodeClickPeople"
                         :loading="drawerCopy2loading">
                <el-option v-for="item in drawFlowOptions" :key="item.id" :label="`${item.name} | ${item.tel} | ${item.departmentName}`"
                           :value="item">
                </el-option>
              </el-select>


            </el-form-item>
            <el-collapse v-model="activeNames">

              <el-collapse-item title="访客通知设置" name="1">
                <el-form-item v-for="(item, index) in visitorNotifySet" :key="index" :label="item.title">
                  <el-checkbox-group v-model="item.value">
                    <el-checkbox :label="item.sysLabel" name="type">系统</el-checkbox>
                    <el-checkbox :label="item.smsLabel" name="type">短信</el-checkbox>
                    <el-checkbox :label="item.email" name="type">邮箱</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-collapse-item>

              <el-collapse-item title="员工通知设置" name="2">
                <el-form-item v-for="(item, index) in employeeNotifySet" :key="index" :label="item.title">
                  <el-checkbox-group v-model="item.value">
                    <el-checkbox :label="item.sysLabel" name="type">系统</el-checkbox>
                    <el-checkbox :label="item.smsLabel" name="type">短信</el-checkbox>
                    <el-checkbox :label="item.email" name="type">邮箱</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-collapse-item>

            </el-collapse>
          </el-form>
        </main>
        <footer>
          <div>
            <el-button type="primary" size="mini" @click="onDrawerSaveClick" :disabled="!hasCommitPermission">保存
            </el-button>
          </div>
          <div style="width: 12px;"></div>
          <template v-if="drawType === `edit`">
            <div>
              <el-button type="danger" size="mini" @click="onDrawerDelClick" :disabled="!hasCommitPermission">删除
              </el-button>
            </div>
            <div style="width: 12px;"></div>
          </template>
          <div>
            <el-button size="mini" @click="onDrawerCancelClick">取消</el-button>
          </div>
        </footer>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import FlowShowView from './FlowShowView.vue'

import {getAllDepartment, getEmployeeByIds, guardSearchEmployee} from '@/api/organize-api'
import {addFlow, delFlow, getValidFlow, updateFlow} from '@/api/flow-api'

export default {
  props: ['visitType'],

  components: {FlowShowView},
  data() {
    return {
      activeNames: [],

      apiParam: "",
      searchText: "",
      drawerShow: false,

      hasSelectFlow: false,

      selectFlow: {},
      selectFlowIndex: -1,

      flowListShow: [],
      flowListAll: [],


      drawFlowForm: {
        name: "",
        timeArea: "",
        targetType: "DEPARTMENT",
        triggerDate: "ALL",
        department: "",
        departmentId: 0,
        people: {},
      },
      drawFlowOptions: [], // peoples

      drawCheckBox: {
        checkBox: [],
      },
      visitorNotifySet: [],
      employeeNotifySet: [
        {title: "预约通知", key: "EMPLOYEE_APPLY_ADD", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {title: "审批通知", key: "EMPLOYEE_APPLY_APPROVE", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {title: "审批结果", key: "EMPLOYEE_APPLY_RESULT", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {title: "抄送通知", key: "EMPLOYEE_APPLY_COPY", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {
          title: "转签通知",
          key: "EMPLOYEE_APPLY_TRANSFER",
          value: [],
          sysLabel: "sys",
          smsLabel: "sms",
          email: "email"
        },
        {title: "到访通知", key: "EMPLOYEE_RECORD_ENTER", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {title: "离开通知", key: "EMPLOYEE_RECORD_LEAVE", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
      ],

      drawType: "new", //new edit
      drawTitle: "新建流程", // 新建流程， 修改流程
      flowMaxId: 456,

      selectTreeDepartment: [],
      departmentList: "",

      defaultProps: {
        children: "departments",
        label: "name",
      },

      drawerCopy2loading: false,
      drawerCopy2Options: [], // peoples
      drawerCopy2Users: [],

    }
  },
  methods: {
    onSearchClick(searchText) {
      if (searchText) {
        this.flowListShow = this.flowListAll.filter(item => {
          return item.name.includes(searchText)
        })
      } else {
        this.flowListShow = this.flowListAll
      }
    },
    onAddClick() {
      this.drawType = "new"       //new edit
      this.drawTitle = "新建流程" // 新建流程， 修改流程
      this.drawFlowForm = {
        name: "",
        timeArea: [new Date(2000, 10, 10, 0, 0), new Date(2000, 10, 10, 23, 59)],
        targetType: "DEPARTMENT",
        triggerDate: "ALL",
        department: "",
        people: "",
      }
      this.visitorNotifySet.forEach(item => {
        item.value = []
      })
      this.employeeNotifySet.forEach(item => {
        item.value = []
      })
      this.drawerShow = true
    },
    onDrawerClosse(done) {
      done()
    },

    async onEdiitClick() {
      this.drawType = "edit"       //new edit
      this.drawTitle = "修改流程" // 新建流程， 修改流程
      let selectFlow = this.selectFlow

      if (selectFlow.setting) {
        selectFlow.setting.forEach(item => {
          if (item.values) {
            this.visitorNotifySet.forEach(item2 => {
              if (item2.key === item.type) {
                item2.value = item.values.split("|")
              }
            })
            this.employeeNotifySet.forEach(item2 => {
              if (item2.key === item.type) {
                item2.value = item.values.split("|")
              }
            })
          }
        })
      }

      let startDate
      let endDate
      if (selectFlow.triggerTimeStart) {
        startDate = new Date(`2000-10-10 ${selectFlow.triggerTimeStart}`)
      } else {
        startDate = new Date(`2000-10-10 09:00:00`)
      }

      if (selectFlow.triggerTimeEnd) {
        endDate = new Date(`2000-10-10 ${selectFlow.triggerTimeEnd}`)
      } else {
        endDate = new Date(`2000-10-10 18:00:00`)
      }

      this.drawFlowForm.name = selectFlow.name

      this.drawFlowForm.timeArea = [startDate, endDate]
      this.drawFlowForm.department = ""
      this.drawFlowForm.departmentId = 0
      this.drawFlowForm.people = ""
      this.drawFlowForm.triggerDate = selectFlow.triggerDate
      this.drawFlowForm.targetType = selectFlow.targetType

      if (this.drawFlowForm.targetType === "DEPARTMENT" && selectFlow.targetValue) {
        let departmentObj = this.findDepartmentById(selectFlow.targetValue)
        console.log("find departmentObj", selectFlow.targetValue, departmentObj);
        if (departmentObj) {
          this.drawFlowForm.department = departmentObj.name
          this.drawFlowForm.departmentId = departmentObj.id
        }
      } else if (this.drawFlowForm.targetType === "PEOPLE" && selectFlow.targetValue) {
        this.drawFlowForm.people = await this.findPeopleById(selectFlow.targetValue)
        this.drawFlowOptions = [this.drawFlowForm.people]
      }
      this.drawerShow = true

    },

    findDepartmentById(id) {
      if (this.selectTreeDepartment) {
        for (const element of this.selectTreeDepartment) {
          console.log("@@@" + element.name);
          let result = this.dofindDepartmentById(id, element)
          if (result) return result
        }
      }
      return {}
    },

    dofindDepartmentById(id, department) {
      if (department.id == id) return department;

      for (const item of department.departments) {
        console.log("@@@" + item.name);
        let result = this.dofindDepartmentById(id, item)
        if (result) return result
      }

      return null;
    },

    async findPeopleById(id) {
      console.log("findPeopleById", id);
      let employee = await getEmployeeByIds([id])
      if (employee.data.code === 200 && employee.data.data.length > 0) {
        console.log("findPeopleById", employee.data.data[0].name);
        return employee.data.data[0]
      }
      return {}
    },

    onDrawerSaveClick() {
      let data
      let formData = this.drawFlowForm
      if (formData.name === "") {
        this.$message({message: "请输入流程名称", type: 'warning'});
        return
      }

      if (this.drawFlowForm.targetType === "DEPARTMENT" && !this.drawFlowForm.departmentId) {
        this.$message({message: "请选择部门", type: 'warning'});
        return
      }

      if (this.drawFlowForm.targetType === "PEOPLE" && !this.drawFlowForm.people.id) {
        this.$message({message: "请选择人员", type: 'warning'});
        return
      }

      if (this.drawType === "new") {
        this.apiParam
        data = {
          business: "VISITOR",
          type: this.apiParam,
          approves: [{type: "SELF"}],
          makeCopies: ""
        }

      } else {
        data = this.selectFlow
      }
      data.name = formData.name
      data.targetType = formData.targetType
      data.triggerDate = formData.triggerDate
      if (formData.targetType === "DEPARTMENT") {
        data.targetValue = formData.departmentId
      } else if (formData.targetType === "PEOPLE") {
        data.targetValue = formData.people.id
      } else {
        data.targetValue = null
      }
      if (formData.timeArea.length >= 1 && formData.timeArea[0]) {
        const date = formData.timeArea[0]
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        data.triggerTimeStart = `${hours}:${minutes}:${seconds}`
      }
      if (formData.timeArea.length >= 2 && formData.timeArea[1]) {
        const date = formData.timeArea[1]
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        data.triggerTimeEnd = `${hours}:${minutes}:${seconds}`
      }

      let setting = []
      this.visitorNotifySet.forEach(item => {
        setting.push({type: item.key, values: item.value.join("|")})
      })
      this.employeeNotifySet.forEach(item => {
        setting.push({type: item.key, values: item.value.join("|")})
      })

      data.setting = setting

      if (this.drawType === "new") {
        this.createflow(data)
      } else {
        this.updateflow(data)
      }
    },
    onDrawerDelClick() {
      let delId = this.selectFlow.id
      delFlow(delId).then(({data}) => {
        console.error("delFlow", data)
        if (data.code === 200) {
          this.hasSelectFlow = false
          let flow = this.flowListAll[this.selectFlowIndex];
          this.flowListAll.splice(this.selectFlowIndex, 1)
          if (this.flowListAll !== this.flowListShow) {
            let indexSelectShow = this.flowListShow.indexOf(flow);
            if (indexSelectShow !== -1) {
              this.flowListShow.splice(indexSelectShow, 1)
            }

          }
          this.selectFlow = {}
          this.selectFlowIndex = -1;
          this.$message({message: data.msg, type: 'success'});
        } else {
          this.showServerErrMsg(data.code);
        }
        this.drawerShow = false
      }).catch(err => {
        console.error("delFlow err", err)
        this.showNetErrMsg();
        this.drawerShow = false
      })
    },
    onDrawerCancelClick() {
      this.drawerShow = false
    },

    nodeClickGroup(e) {
      console.log(e);
      this.drawFlowForm.department = e.name
      this.drawFlowForm.departmentId = e.id

    },
    NodeClickPeople(query) {
      this.drawerCopy2loading = true;
      if (query !== '') {
        let param = {}
        if (isNaN(query)) {
          param = {name: query}
        } else {
          param = {tel: query}
        }
        guardSearchEmployee(param).then(({data}) => {
          if (data.code === 200) {
            this.drawFlowOptions = data.data
          }
          this.drawerCopy2loading = false;
        }).catch(err => {
          console.log(err)
          this.drawerCopy2loading = false;
        })
      } else {
        this.drawFlowOptions = []
        this.drawerCopy2loading = false;
      }
    },

    getChildMsg(param1, param2) {

      console.log("@@@", "getChildMsg", param1, param2);
      if (param1 === 'saveFlow') {
        this.selectFlow.approves = param2
        this.updateflow(this.selectFlow)
      } else if (param1 === 'add') {
        this.flowMaxId++
        if (param2 === -1) {
          this.selectFlow.approves.push({id: this.flowMaxId, comments: "", type: "SELF"})
        } else {
          this.selectFlow.approves.splice(param2, 0, {id: this.flowMaxId, comments: "", type: "SELF"})
        }
        this.updateflow(this.selectFlow)
      } else if (param1 === 'saveCopyTo') {
        let senterTo = []
        param2.forEach(element => {
          senterTo.push(element.id)
        });
        this.selectFlow.makeCopies = senterTo.join('|')
        this.updateflow(this.selectFlow)

      } else if (param1 === 'del') {
        console.log("@@@@@@", "del", param2);
        this.selectFlow.approves.splice(param2, 1)
        this.updateflow(this.selectFlow)
      }
    },

    updateflow(flow) {
      if (!this.hasCommitPermission) {
        return
      }
      console.log("updateflow", flow);
      updateFlow(flow).then(({data}) => {
        console.log("updateFlow", data);
        if (data.code === 200) {

          if (this.flowListAll != this.flowListShow) {
            let flow = this.flowListAll[this.selectFlowIndex]
            let showIndex = this.flowListShow.indexOf(flow)
            if (showIndex != -1) {
              this.flowListShow.splice(showIndex, 1, data.data[0])
            }
          }

          this.flowListAll.splice(this.selectFlowIndex, 1, data.data[0])

          this.$message({message: data.msg, type: 'success'});
        } else if (data.code === 700) {
          this.$message.error("流程冲突");
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((err) => {
        this.showNetErrMsg();
        console.log("updateFlow err", err);
      })
      this.drawerShow = false
    },

    createflow(flow) {
      console.log("createflow", flow.name);
      console.log("createflow", flow);
      addFlow(flow).then(({data}) => {
        console.log("createflow", flow.name, "result", data.code);
        console.log("createflow", "result data", data);
        if (data.code === 200) {
          this.$message({message: data.msg, type: 'success'});
          this.flowListAll.push(data.data[0])
        } else if (data.code === 700) {
          this.$message.error("流程冲突");
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(() => {
        this.showNetErrMsg();
      })
      this.drawerShow = false
    },

    onFlowClick(flow) {
      console.log("onFlowClick", flow.name);

      this.selectFlow = JSON.parse(JSON.stringify(flow));
      this.hasSelectFlow = true
      this.selectFlowIndex = this.flowListAll.indexOf(flow)
      console.log("onFlowClick get index ", this.selectFlowIndex);

    }
  },// end methods

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("VISITOR_FLOW_MODIFY")
        default:
          return false
      }
    }
  },

  mounted() {

    if (this.visitType === "subscribe") {
      this.apiParam = "BOOK"
    } else if (this.visitType === "invite") {
      this.apiParam = "INVITE"
    }

    getValidFlow(this.apiParam).then(({data}) => {
      console.log("getValidFlow", data)
      this.flowListAll = data.data
      this.flowListShow = data.data
    }).catch((err) => {
      console.log("getValidFlow err", err)
    })

    // 获取员工与组织列表
    getAllDepartment().then(({data}) => {
      this.selectTreeDepartment = data.data
    }).catch((err) => {
      console.error("getAllDepartment err", err);
    })

    this.visitorNotifySet = []
    if (this.visitType === "subscribe") {
      this.visitorNotifySet.push(
          {title: "预约申请", key: "VISITOR_APPLY_ADD", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
      )
    } else if (this.visitType === "invite") {
      this.visitorNotifySet.push(
          {title: "邀约申请", key: "VISITOR_APPLY_ADD", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
      )
    }
    this.visitorNotifySet.push(
        {title: "撤销通知", key: "VISITOR_APPLY_CANCEL", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {title: "审批结果", key: "VISITOR_APPLY_RESULT", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {
          title: "陪同结果",
          key: "VISITOR_APPLY_ACCOMPANY",
          value: [],
          sysLabel: "sys",
          smsLabel: "sms",
          email: "email"
        },
        {title: "接待通知", key: "VISITOR_RECORD_ENTER", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
        {title: "离开通知", key: "VISITOR_RECORD_LEAVE", value: [], sysLabel: "sys", smsLabel: "sms", email: "email"},
    )
  }


}

</script>
<style lang="less" scoped>
.flow-setting {
  display: flex;
  justify-content: flex-start;

  .left-area {
    .left-top {
      display: flex;
      margin: 0px 0px 5px 0px;
    }

    .left-content {
      height: 500px;
      overflow-y: auto;
    }

    .left-bottom-btn {
      width: 100%;
    }
  }

  .right-area {
    display: flex;

    .main-form {
      position: relative;

      margin: 0 auto;
      width: 500px;
    }

    .form-item-width {
      width: 350px;
    }

    .edit-btn {
      position: absolute;
      top: 1px;
      right: 1px;
    }
  }
}

.drawer-title {
  padding-left: 10px;
  padding-top: 10px;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* 设置容器高度占满整个视口 */


  header {
    height: 50px;
    line-height: 50px;
    padding-left: 12px;
    /* 固定头部高度 */
    border-bottom: 1px solid gray;
  }

  main {
    flex: 1;
    /* 中间内容自动拉伸 */
    border-bottom: 1px solid gray;

    padding: 12px;

  }

  footer {
    height: 50px;
    display: flex;
    justify-content: center;

    div {
      height: 50px;
      line-height: 50px;
    }

    /* 固定底部高度 */
  }

  .button-ensure {
    margin: 0 10px;
    /* 左右间距 */
  }

  .button-cancel {
    margin: 0 10px;
    /* 左右间距 */
  }
}

.select-width {
  width: 80%;
}

</style>
